import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import liveStream from "./livestream.module";
import user from "./user.module";
import comment from "./comment.module";
import notification from "./notification.module";
import club from "./club.module";
import schedule from "./schedule.module";
import newsfeed from "./newsfeed.module";
import file from "./file.module";
import configuration from "./configuration.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    liveStream,
    user,
    comment,
    notification,
    club,
    schedule,
    newsfeed,
    file,
    configuration
  }
});
